import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Home from './pages/Home';
import Login from './pages/Login';
import AdminPage from './pages/AdminPage';
import WishesGallery from './pages/WishesGallery';
import MediaEditor from './pages/MediaEditor';
import AutoModeEditor from './pages/AutoModeEditor';
import PersonalizePage from './pages/PersonalizePage';
import LanguagesPage from './pages/LanguagesPage';
import PWAInstallPrompt from './components/common/PWAInstallPrompt';
import DesktopBlocker from './components/common/DesktopBlocker';
import './App.css';

function AppContent() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin') || location.pathname.startsWith('/imcloginforadmin');

  // Don't show desktop blocker on admin routes
  if (isAdminRoute) {
    return (
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wishes" element={<WishesGallery />} />
          <Route path="/wishes/editor/:id" element={<MediaEditor />} />
          <Route path="/wishes/auto/:id" element={<AutoModeEditor />} />
          <Route path="/media-editor/:id" element={<MediaEditor />} />
          <Route path="/personalize" element={<PersonalizePage />} />
          <Route path="/languages" element={<LanguagesPage />} />
          <Route path="/imcloginforadmin" element={<Login />} />
          <Route path="/admin/*" element={<AdminPage />} />
        </Routes>
        <PWAInstallPrompt />
      </div>
    );
  }

  // Show desktop blocker for public routes
  return (
    <DesktopBlocker>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wishes" element={<WishesGallery />} />
          <Route path="/wishes/editor/:id" element={<MediaEditor />} />
          <Route path="/wishes/auto/:id" element={<AutoModeEditor />} />
          <Route path="/media-editor/:id" element={<MediaEditor />} />
          <Route path="/personalize" element={<PersonalizePage />} />
          <Route path="/languages" element={<LanguagesPage />} />
          <Route path="/imcloginforadmin" element={<Login />} />
          <Route path="/admin/*" element={<AdminPage />} />
        </Routes>
        <PWAInstallPrompt />
      </div>
    </DesktopBlocker>
  );
}

function App() {
  return (
    <Router>
      <LanguageProvider>
        <ThemeProvider>
          <AuthProvider>
            <AppContent />
          </AuthProvider>
        </ThemeProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
